import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import PublicLayout from '@layout/PublicLayout';
import { GeneralContent } from '@layout/Layout.style';
import { useGeolocation } from '@hooks';
import useSignDocumentsNavigation from './hooks';
const SignDocuments = () => {
    const navigate = useNavigate();
    const signDocumentsNavigation = useSignDocumentsNavigation();
    const { pathname } = useLocation();
    const { geolocationStatus, getCurrentPosition, getGeolocationStatus } = useGeolocation();
    useEffect(() => {
        if (geolocationStatus === 'granted') {
            signDocumentsNavigation.navigateToFirstPendingStep();
        }
        else if (geolocationStatus === 'denied' || geolocationStatus === 'prompt') {
            if (!pathname.includes('enable-location'))
                navigate('enable-location');
        }
    }, [geolocationStatus]);
    return (_jsx(PublicLayout, { children: _jsx(GeneralContent, { children: ((!pathname.includes('enable-location') && geolocationStatus === 'granted')
                || pathname.includes('enable-location'))
                && (_jsx(Outlet, { context: {
                        signDocumentsNavigation,
                        getCurrentPosition,
                        getGeolocationStatus
                    } })) }) }));
};
export default SignDocuments;
